import React, { useEffect, useState } from "react";
import AppSettingsService from "../../../services/appSettings";

export const NOTE_WHEN_OFF = "'Own patients only' is off in Settings, so every clinician sees all patients and these boxes have no effect yet.";
export const NOTE_WHEN_ON = "'Own patients only' is on. Ticked clinicians see all patients; everyone else sees only their own. Search always finds any patient.";

/**
 * superAdmin only, above the Clinicians table: says whether the "Own patients only" switch in
 * Settings is on, and so what the "Exempt from 'Own patients only'" boxes do right now. Read when the
 * page opens. If the setting cannot be read the note is left out (no error toast) - the column's own
 * words still say what a tick means.
 */
const OwnPatientsOnlyNote = () => {
    const [enabled, setEnabled] = useState(null);

    useEffect(() => {
        let current = true;
        (async () => {
            try {
                const { data } = await AppSettingsService.getSettingsQuietly();
                const value = data && data.patientListRestriction ? data.patientListRestriction.enabled : null;
                if (current && typeof value === "boolean") {
                    setEnabled(value);
                }
            } catch {
                // Left out: see above.
            }
        })();
        return () => { current = false; };
    }, []);

    if (enabled === null) {
        return null;
    }

    return (
        <div className="text-muted font-size-13 mb-3" data-testid="own-patients-only-note">
            {enabled ? NOTE_WHEN_ON : NOTE_WHEN_OFF}
        </div>
    );
};

export default OwnPatientsOnlyNote;
